// noinspection DuplicatedCode

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Select from '@/modules/common/components/Select';
import PostBackUrlField from '@/modules/common/components/PostBackUrlField/PostBackUrlField';

const Form = (props) => {
    const getOfferOptions = () => {
        return props.offers.map((offer) => ({title: offer.offer_name, value: offer.id.toString()}));
    };

    const getTypeOptions = () => {
        let options = [];
        const id = parseInt(props.values.offer);
        if (!isNaN(id)) {
            const types = props.types.filter((type) => type.offer.id === id);
            options = types.map((type) => ({title: type.name, value: type.id.toString()}));
        }
        return options;
    };

    const getStatusOptions = () => {
        let options = [];
        const id = parseInt(props.values.offer);
        if (!isNaN(id)) {
            const statuses = props.statuses.filter((status) => status.offer.id === id);
            options = statuses.map((status) => ({title: status.status, value: status.id.toString()}));
        }
        return options;
    };

    const handleChange = (prop) => (event) => {
        props.setValues({...props.values, [prop]: event.target.value});
    };

    const handleFocus = (prop) => () => {
        props.setErrors({...props.errors, [prop]: ''});
    };

    return (
        <>
            <Select label="Оффер" options={getOfferOptions()}
                    value={props.values.offer}
                    onChange={(event) => {
                        props.setValues({
                            ...props.initialValues,
                            'offer': event.target.value,
                            'url': props.values.url
                        });
                    }}
                    error={props.errors.offer.length > 0}
                    helperText={props.errors.offer}
                    onFocus={handleFocus('offer')}
                    autoFocus={true}
            />
            <Select label="Тип заявки" options={getTypeOptions()}
                    value={props.values.type} onChange={handleChange('type')}
                    error={props.errors.type.length > 0}
                    helperText={props.errors.type}
                    onFocus={handleFocus('type')}
            />
            <Select label="Статус" options={getStatusOptions()}
                    value={props.values.status} onChange={handleChange('status')}
                    error={props.errors.status.length > 0}
                    helperText={props.errors.status}
                    onFocus={handleFocus('status')}
            />
            <PostBackUrlField value={props.values.url} onChange={handleChange('url')}
                              error={props.errors.url.length > 0}
                              helperText={props.errors.url}
                              onFocus={handleFocus('url')}
            />
        </>
    );
};

Form.propTypes = {
    initialValues: PropTypes.object.isRequired,
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
    setErrors: PropTypes.func.isRequired,
};

export default connect(
    (state) => ({
        types: state.types,
        offers: state.cfg.offers,
        statuses: state.statuses,
    }),
    null
)(Form);
